// src/componentes/Clientes/TarjetaCliente.jsx
import React from "react";
import BarcodeWrapper from "../barcode";
import "./TarjetaCliente.css";

/**
 * Tarjeta para entregar al cliente.
 * Espera un objeto cliente con al menos:
 * { id, nombre, apellidos }
 * y opcionalmente una deuda principal: { id, folio }
 */
const TarjetaCliente = ({ cliente, deudaPrincipal }) => {
  if (!cliente) return null;

  const codigoCliente = `C:${cliente.id}`; // código para buscar por cliente
  const codigoDeuda = deudaPrincipal ? `D:${deudaPrincipal.id}` : null;

  return (
    <div className="tarjeta-cliente">
      <div className="tarjeta-header">
        <h3>GRUPO INMOBILIARIO K&E</h3>
        <p>Tarjeta de Cliente</p>
      </div>

      <div className="tarjeta-body">
        <p>
          <strong>Cliente:</strong> {cliente.nombre} {cliente.apellidos}
        </p>
        {deudaPrincipal && (
          <p>
            <strong>Deuda principal:</strong>{" "}
            {deudaPrincipal.folio || deudaPrincipal.id}
          </p>
        )}

        <div className="tarjeta-barcode-section">
          <div className="tarjeta-barcode">
            <small>ID Cliente</small>
            <BarcodeWrapper value={codigoCliente} width={2} height={60} />
          </div>

          {codigoDeuda && (
            <div className="tarjeta-barcode">
              <small>ID Deuda</small>
              <BarcodeWrapper value={codigoDeuda} width={2} height={50} />
            </div>
          )}
        </div>
      </div>

      <div className="tarjeta-footer">
        <small>Escanea este código para localizar rápidamente al cliente o su deuda.</small>
      </div>
    </div>
  );
};

export default TarjetaCliente;